'use client'

import { useState } from 'react'
import { useRouter } from 'next/navigation'
import { Button } from '@/components/ui/button'

/**
 * Starts a new SAT attempt in untimed practice mode.
 * Works like StartSatButton but appends `?practice=1` to the goto URL.
 */
export default function StartSatPracticeButton({ children }: { children: React.ReactNode }) {
  const router = useRouter()
  const [busy, setBusy] = useState(false)

  return (
    <Button
      variant="secondary"
      disabled={busy}
      onClick={async () => {
        try {
          setBusy(true)
          const r = await fetch('/api/sat/start', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            // No form id: the server picks the form. One sent from the page put
            // the Benchmark form's id in its HTML (practice-pool.ts).
            body: JSON.stringify({}),
          })
          if (!r.ok) {
            router.push('/sat/resume')
            return
          }
          const data = await r.json()
          const goto = data?.goto ?? '/sat/resume'
          // Append practice query param
          const separator = goto.includes('?') ? '&' : '?'
          router.push(`${goto}${separator}practice=1`)
        } finally {
          setBusy(false)
        }
      }}
    >
      {busy ? 'Starting...' : children}
    </Button>
  )
}
